import {lazy, Suspense, useEffect, useMemo, useState} from 'react';
import {AnnouncementMessageModel} from 'web-library/stories/molecule/Announcement/Announcement';
import {AnnouncementDetail} from 'web-library/models/Announcements';
import {usePostSearchAnnouncements} from '../../api-refactored/announcements/usePostSearchAnnouncements';
import {useGetAnnouncementNoticeDetails} from '../../api-refactored/announcements/useGetAnnouncementNoticeDetails';
import AdvisoryBannerContent from "../../modules/announcement/components/AdvisoryBannerContent";

const LoginForm = lazy(() => import('../../modules/profile/components/LoginForm'));
const Announcement = lazy(() => import('web-library/stories/molecule/Announcement/Announcement'));

const Login = () => {
  const [announcement, setAnnouncement] = useState<AnnouncementDetail[]>([]);
  const [isAnnouncement, setIsAnnouncement] = useState<boolean>(false);
  const [announcementNoticeDetails, setAnnouncementNoticeDetails] = useState<AnnouncementDetail>();

  const [openAnnouncementModal, setOpenAnnouncementModal] = useState<boolean>(false);

  /** retrieve candidate announcements
   * */
  const {mutate: postSearchAnnouncements} = usePostSearchAnnouncements({
    onSuccess: (data) => {
      setAnnouncement(data.content);
      setIsAnnouncement(data.content.length > 0);
    },
    isRedirect: false,
  });

  const {data: announcementNoticeDetailForModal} = useGetAnnouncementNoticeDetails({
    announcementType: 'BROADCAST_MESSAGE',
    announcementUuid: announcementNoticeDetails?.uuid || '',
    enabled: !!announcementNoticeDetails?.uuid,
  });

  const openBroadcastModal = (index: number) => {
    setAnnouncementNoticeDetails(announcement[index]);
    setOpenAnnouncementModal(true);
  };

  /** memorize announcements
   * */
  const transformAnnouncements = useMemo<AnnouncementMessageModel[]>(() => {
    if (announcement) {
      return announcement.map((m) => ({
        message: m.title,
        showReadMore: !!m.description,
      }));
    }
    return [];
  }, [announcement]);

  /** handle announcements close
   * */
  const onAnnouncements = () => {
    setAnnouncement([]);
  };

  /** handle announcements open
   * */
  const onAnnouncementsOpen = () => {
    postSearchAnnouncements({q: '', announcementType: 'BROADCAST_MESSAGE', apiPathParam: {}});
  };

  useEffect(() => {
    onAnnouncementsOpen();
    /*  eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const handleCloseAnnouncementModal = () => {
    setOpenAnnouncementModal(false);
  };

  return (
      <>
        {announcement && announcement.length > 0 && (
            <Suspense fallback={null}>
              <Announcement
                  messages={transformAnnouncements}
                  onClose={onAnnouncements}
                  onClickReadMore={openBroadcastModal}
              />
            </Suspense>
        )}
        <AdvisoryBannerContent/>
        <Suspense fallback={null}>
          <LoginForm
              isAnnouncement={isAnnouncement}
              onAnnouncementOpen={onAnnouncementsOpen}
              announcementNoticeDetails={announcementNoticeDetailForModal}
              handleCloseAnnouncementModal={handleCloseAnnouncementModal}
              openAnnouncementModal={openAnnouncementModal}
          />
        </Suspense>
      </>
  );
};

export default Login;
